import { useMemo } from 'react'

export const useEntryInspector = ({
  contentTypeId = '',
  contentTemplateId = '',
  entryId = '',
}) =>
  useMemo(
    () => () => ({
      [`data-content-type-id`]: contentTypeId,
      [`data-content-template-id`]: contentTemplateId,
      [`data-entry-id`]: entryId,
    }),
    [contentTypeId, contentTemplateId, entryId]
  )
